/**
 * This file is the entry point for all routes in the application.
 * React Router is used to define the routes and their corresponding components.
 */
import React from 'react'
import { BrowserRouter as Router, Navigate, useLocation } from 'react-router-dom'
import { CircularProgress, Backdrop } from '@mui/material'
/** ROUTES */
import AuthRoutes from './authRoutes'
/** HOOK */
import { useAuth } from '@hooks/auth'
/** LAYOUT */
import MainLayout from '@/layout/main2'
const ProtectedComponent = ({ isAuthenticated, location }: { isAuthenticated: boolean; location?: string }) => {
	const ProtectedRoutes = React.lazy(() => import('./protectedRoutes'))

	if (!isAuthenticated) {
		return null
	}

	return (
		<React.Suspense
			fallback={
				<Backdrop
					open={true}
					sx={{
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
					}}
				>
					<CircularProgress color="inherit" />
				</Backdrop>
			}
		>
			<MainLayout>
				<ProtectedRoutes isAuthenticated={isAuthenticated} />
			</MainLayout>
		</React.Suspense>
	)
}

const AppRouter = () => {
	const { isAuthenticated, isLoading } = useAuth()

	return (
		<>
			<Router>
				{!isAuthenticated && !isLoading ? (
					<AuthRoutes />
				) : (
					<ProtectedComponent isAuthenticated={isAuthenticated} />
				)}
			</Router>
		</>
	)
}

export default AppRouter
